"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    name: 'applicationError',
    modelName: 'applicationError',
    tableName: 'applicationError',
    collectionName: 'applicationerrors',
    index: [{ definition: { 'origin.companyId': 1 } }, { definition: { type: 1 } }],
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/ApplicationError/modelProperties.js.map